export const formatUkDate = (value?: string | null): string => {
  if (!value) return ''
  const trimmed = String(value).trim()
  if (!trimmed) return ''

  // Parse YYYY-MM-DD explicitly to avoid timezone shifts.
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})/)
  if (isoMatch) {
    const [, year, month, day] = isoMatch
    const date = new Date(Number(year), Number(month) - 1, Number(day))
    if (!Number.isNaN(date.getTime())) {
      return new Intl.DateTimeFormat('en-GB', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(date)
    }
  }

  const fallback = new Date(trimmed)
  if (!Number.isNaN(fallback.getTime())) {
    return new Intl.DateTimeFormat('en-GB', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    }).format(fallback)
  }

  return trimmed
}

export const formatJurisdiction = (value?: string): string => {
  if (!value) return ''

  const trimmed = value.trim()
  if (!trimmed) return ''

  // Handle specific case for england-wales
  const normalized = trimmed.toLowerCase()
  if (normalized === 'england-wales') {
    return 'England - Wales'
  }

  // Capitalize other jurisdiction strings
  // Split by hyphens or spaces, capitalize each word, and join with original separator
  const hasHyphen = trimmed.includes('-')
  
  return trimmed
    .split(hasHyphen ? '-' : ' ')
    .map(word => {
      if (!word) return word
      return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    })
    .join(hasHyphen ? ' - ' : ' ')
}

